<template>
    <div ref="label"
         v-resize
         @resize="resizeListenerDebounced"
         @click="$emit('click', $event)">{{truncatedLabel}}</div>
</template>

<script>
const MAX_FIRST_PART_LENGTH = 6
const DEFAULT_FONT = '14px Roboto'
/**
 * Used for customization of truncation functionality to force url to fit available space
 * @example:
 * https://acme.com/some-second-path-segment -> acme.co...ond-path-segment
 */
export default {
  name: 'BaseTruncateLabel',
  created () {
    this.addResizeEventListener()
  },
  mounted () {
    this.resizeListener()
  },
  // destroyed () {
  //   this.resizeListenerDebounced && window.removeEventListener('resize', this.resizeListenerDebounced)
  // },
  /** @param watchClass - class for measuring available width for label.
   * @param shrink - multiplier that define what part of full width of watchClass can be occupied by label
   */
  props: {
    'label': String,
    'shrink': Number,
    'watchClass': String,
    'font': String,
    'watchModificator': {
      type: String,
      default: ''
    },
    checkAllDocument: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      truncatedLabel: '',
      resizeListenerDebounced: null,
      watchedElementWidth: 0
    }
  },
  watch: {
    watchedElementWidth: {
      handler (width) {
        if (width) {
          this.recalculateLabel()
        }
      },
      immediate: true
    },
    label: {
      handler (value) {
        if (value) {
          this.$nextTick(this.recalculateLabel)
        }
      },
      immediate: true
    }
  },
  methods: {
    resizeListener () {
      const elements = !this.checkAllDocument && this.$parent && this.$parent.$el ? this.$parent.$el.querySelectorAll('.' + this.watchClass + this.watchModificator) : document.getElementsByClassName(this.watchClass)
      const element = elements && elements.length ? elements[0] : null
      if (_.isNull(element)) {
        return
      }
      const paddingLeft = (window.getComputedStyle(element).getPropertyValue('padding-left') || '').replace('px', '') || 0
      this.watchedElementWidth = element.clientWidth - parseInt(paddingLeft)
    },
    truncateTextByLength (text, maxLength, shrink) {
      maxLength = parseInt(shrink * maxLength)
      if (text.length > maxLength) {
        text = `${text.substring(0, MAX_FIRST_PART_LENGTH)}...${text.substring(text.length - (maxLength - MAX_FIRST_PART_LENGTH))}`
      }
      return text
    },
    getTruncateText (text, containerWidth, { font = DEFAULT_FONT, shrink = 0.85 }) {
      if (!text || !containerWidth) {
        return 'Not enough data'
      }
      const prefixes = ['http://www.', 'https://www.', 'https://', 'http://']
      prefixes.forEach(item => {
        if (text.startsWith(item)) {
          text = text.split(item)[1]
        }
      })
      /* measure real text width and how mach it should be cut */
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = font
      const width = ctx.measureText(text).width
      const ratio = containerWidth / width
      if (ratio >= 1) {
        return text
      }
      const requiredLength = parseInt(text.length * ratio)
      return this.truncateTextByLength(text, requiredLength, shrink)
    },
    addResizeEventListener () {
      this.resizeListenerDebounced = _.throttle(this.resizeListener, 500, { trailing: true })
      // window.addEventListener('resize', this.resizeListenerDebounced, false)
    },
    recalculateLabel () {
      if (parseInt(this.watchedElementWidth) === 0) {
        this.resizeListener()
      }
      this.truncatedLabel = this.getTruncateText(this.label, this.watchedElementWidth, { shrink: this.shrink, font: this.font })
    }
  }
}
</script>

<style scoped>

</style>
